import React from "react";
import { useHistory } from "react-router-dom";
import OTP from "../../components/OTP/OTP";
import { unAuthenticatedRoutes } from "../../routes/constant";
import AuthService from "../../services/auth.service";
import notificationService from "../../util/notification.service";
import utilService from "../../util/utils.service";

const EnterOTP = (props) => {
    const [counter, setCounter] = React.useState(30);

    React.useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);
    const history = useHistory();

    const onFinish = async (otp) => {
        const { ok } = await AuthService.verifyOtp({
            otp: +otp,
            email: history?.location?.state,
        });

        if (ok) {
            notificationService.info(`OTP Verified!`);
            history.replace(unAuthenticatedRoutes.RESET_PASSWORD, {
                email: history?.location?.state,
                otp: otp,
            });
        } else {
            notificationService.error("Invalid OTP code!");
        }
    };

    const resendOTP = async () => {
        const { ok } = await AuthService.forgetPassword({
            email: history?.location?.state,
        });

        if (ok) {
            notificationService.info(
                `OTP resent to ${props?.history?.location?.state}`
            );
            setTimeout(() => {
                return utilService.redirectTo(unAuthenticatedRoutes.ENTEROTP);
            }, 2000);
        } else {
            notificationService.error("Error!");
        }
    };

 

    return (
        <div className="gx-app-login-wrap reset-pass-main">
            <OTP onSubmit={(o) => onFinish(o)} resendOTP={resendOTP} />
        </div>
    );
};

export default EnterOTP;
